import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "NewWaypointsForm" }
const _hoisted_2 = { class: "NewWaypointsForm__selected" }
const _hoisted_3 = { class: "selected__title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Редактировать ")
const _hoisted_5 = {
  key: 0,
  class: "selected__hint"
}
const _hoisted_6 = { class: "selected__template" }
const _hoisted_7 = { class: "template__header" }
const _hoisted_8 = { class: "header__title" }
const _hoisted_9 = { class: "header__position" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Отправной пункт")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Конечный пункт")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Промежуточный пункт")
const _hoisted_13 = { class: "template__body" }
const _hoisted_14 = { class: "body__fullname" }
const _hoisted_15 = { class: "body__phone" }
const _hoisted_16 = {
  key: 0,
  style: {"margin-top":"12px"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Самопривоз")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Самовывоз")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash mr-2" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_21 = {
  key: 0,
  class: "NewWaypointsForm__form"
}
const _hoisted_22 = { class: "form__title" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Выбор пунктов")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Выберите конечный пункт")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Выберите отправной пункт")
const _hoisted_26 = { class: "form__scrollable scroll ftl" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Новый получатель")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Новый отправитель")
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "Загрузить еще", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "Загрузить еще", -1)
const _hoisted_31 = {
  key: 1,
  class: "NewWaypointsForm__confirm"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Завершить выбор пунктов ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_button = _resolveComponent("s-button")!
  const _component_additional_services = _resolveComponent("additional-services")!
  const _component_icon_draggable = _resolveComponent("icon-draggable")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_icon_big_plus = _resolveComponent("icon-big-plus")!
  const _component_point_in_panel = _resolveComponent("point-in-panel")!
  const _component_panels_loader = _resolveComponent("panels-loader")!
  const _component_sender_create = _resolveComponent("sender-create")!
  const _component_s_modal = _resolveComponent("s-modal")!
  const _component_receiver_create = _resolveComponent("receiver-create")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, [
        _createTextVNode(" Выбранные пункты (" + _toDisplayString(_ctx.state.selected_templates.length) + ") ", 1),
        (_ctx.completed)
          ? (_openBlock(), _createBlock(_component_s_button, {
              key: 0,
              disabled: _ctx.disabled,
              class: "green small",
              onClick: _ctx.onEdit
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.completed)
        ? (_openBlock(), _createBlock("p", _hoisted_5, "(вы можете изменять очередность пунктов)"))
        : _createCommentVNode("", true),
      (_ctx.opened)
        ? (_openBlock(), _createBlock(_component_draggable, {
            key: 1,
            list: _ctx.state.selected_templates,
            handle: ".drag",
            "item-key": "id",
            tag: "transition-group",
            "component-data": {
                    tag: 'ul',
                    type: 'transition-group',
                    name: !_ctx.state.drag ? 'flip-list' : null,
                },
            animation: 200,
            move: _ctx.onDragMove,
            onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.drag = true)),
            onEnd: _ctx.onDragEnd
          }, {
            item: _withCtx(({ element, index }) => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(element.title), 1),
                  _createVNode("span", _hoisted_9, [
                    (index === 0)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_10
                        ], 64))
                      : (index === _ctx.state.selected_templates.length - 1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_11
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                            _hoisted_12
                          ], 64))
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_14, _toDisplayString(element.full_name), 1),
                    _createVNode("span", _hoisted_15, _toDisplayString(element.phone), 1)
                  ]),
                  _createVNode("p", null, _toDisplayString(element.full_address), 1),
                  (Boolean(element.warehouse_id))
                    ? (_openBlock(), _createBlock("p", _hoisted_16, [
                        (index === 0)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _hoisted_17
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _hoisted_18
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_additional_services, {
                  setted: element.is_additional_services_setted,
                  closable: element.is_additional_services_setted,
                  onContinue: (services) => _ctx.setAdditionalServices(services, element),
                  onClose: ($event: any) => (_ctx.resetAdditionalServices(element))
                }, null, 8, ["setted", "closable", "onContinue", "onClose"]),
                (!_ctx.completed && !_ctx.disabled)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: ["template__footer", {
                                'footer--disabled': index === 0,
                            }]
                    }, [
                      (index !== 0)
                        ? (_openBlock(), _createBlock(_component_icon_draggable, {
                            key: 0,
                            class: "footer__draggable drag"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_s_button, {
                        disabled: _ctx.disabled,
                        class: "red small text",
                        onClick: ($event: any) => (_ctx.onSelectedTemplateDelete(index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["list", "component-data", "move", "onEnd"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.completed)
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("h2", _hoisted_22, [
            (!_ctx.opened)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_23
                ], 64))
              : (_ctx.isSenderSelected)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_24
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _hoisted_25
                  ], 64))
          ]),
          (_ctx.opened)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_s_input, {
                  class: "form__search",
                  placeholder: "Поиск по номеру телефона, адресу или названию",
                  value: _ctx.state.search_query,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.search_query = $event)),
                  onInput: _ctx.onTemplateSearch
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_icon_search)
                  ]),
                  _: 1
                }, 8, ["value", "onInput"]),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_s_button, {
                    class: "scrollable__add red",
                    onClick: _ctx.onStartCreateTemplate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_icon_big_plus),
                      _createVNode("span", null, [
                        (_ctx.isSenderSelected)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _hoisted_27
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _hoisted_28
                            ], 64))
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.isSenderSelected)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_state.receivers.list, (template, i) => {
                          return (_openBlock(), _createBlock(_component_point_in_panel, {
                            key: `TemplatePointInPanel-${i}`,
                            point: template,
                            selected: _ctx.checkIfTemplateSelected(template.id),
                            "is-receiver": "",
                            isFTL: "",
                            onEdit: _ctx.onStartEditTemplate,
                            onSelect: _ctx.onTemplateSelect,
                            onDelete: _ctx.onTemplateDelete
                          }, null, 8, ["point", "selected", "onEdit", "onSelect", "onDelete"]))
                        }), 128)),
                        (!_ctx.data_state.receivers.is_loading)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              (
                                    _ctx.data_state.receivers.pagination.current_page <
                                        _ctx.data_state.receivers.pagination.total_pages &&
                                    !_ctx.state.is_search
                                )
                                ? (_openBlock(), _createBlock(_component_s_button, {
                                    key: 0,
                                    class: "scrollable__add red",
                                    onClick: _ctx.onLoadMoreTemplates
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_29
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_state.senders.list, (template, i) => {
                          return (_openBlock(), _createBlock(_component_point_in_panel, {
                            key: `TemplatePointInPanel-${i}`,
                            point: template,
                            selected: _ctx.checkIfTemplateSelected(template.id),
                            "is-sender": "",
                            isFTL: "",
                            onSelect: _ctx.onTemplateSelect,
                            onEdit: _ctx.onStartEditTemplate,
                            onDelete: _ctx.onTemplateDelete
                          }, null, 8, ["point", "selected", "onSelect", "onEdit", "onDelete"]))
                        }), 128)),
                        (!_ctx.data_state.senders.is_loading)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              (
                                    _ctx.data_state.senders.pagination.current_page <
                                        _ctx.data_state.senders.pagination.total_pages &&
                                    !_ctx.state.is_search
                                )
                                ? (_openBlock(), _createBlock(_component_s_button, {
                                    key: 0,
                                    class: "scrollable__add red",
                                    onClick: _ctx.onLoadMoreTemplates
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64)),
                  (_ctx.isLoadingState)
                    ? (_openBlock(), _createBlock(_component_panels_loader, { key: 2 }))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.opened && !_ctx.completed)
      ? (_openBlock(), _createBlock("div", _hoisted_31, [
          _createVNode(_component_s_button, {
            disabled: _ctx.disabled,
            class: "red",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSenderActionsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 2,
          onClose: _ctx.closeSenderActions
        }, {
          body: _withCtx(() => [
            _createVNode(_component_sender_create, {
              onCreate: _ctx.onTemplateCreate,
              onUpdate: _ctx.onTemplateUpdate,
              onClose: _ctx.closeSenderActions
            }, null, 8, ["onCreate", "onUpdate", "onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isReceiverActionsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 3,
          onClose: _ctx.closeReceiverActions
        }, {
          body: _withCtx(() => [
            _createVNode(_component_receiver_create, {
              isFTL: "",
              onCreate: _ctx.onTemplateCreate,
              onUpdate: _ctx.onTemplateUpdate,
              onClose: _ctx.closeReceiverActions
            }, null, 8, ["onCreate", "onUpdate", "onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}